// A promo code from the park office (packages/db promos.ts): park money, maybe the Route Pass
// premium track, once per player. The server checks the code and pays it; this only types it in.
// A plain field, the same one-line row as the park code on the menu (no clipboard in the frame).
import { type FormEvent, useState } from 'react';
import { errorText } from '../App';
import { api } from '../lib/api';
import { parkNaira } from '../lib/money';
import { useUi } from '../store/ui';
import { S } from '../strings';

export function RedeemCode({ onRedeemed }: { onRedeemed?: () => void }) {
  const set = useUi((s) => s.set);
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const ready = code.length >= 4 && !busy;
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!ready) return;
    setBusy(true);
    set({ notice: null });
    try {
      const r = await api.redeem(code);
      const words = [r.coins > 0 ? S.promo.worked(parkNaira(r.coins)) : '', r.passPremium ? S.promo.pass : '']
        .filter(Boolean)
        .join(' ');
      set({ notice: words, noticeTone: 'done', coins: r.balance });
      setCode('');
      onRedeemed?.();
    } catch (err) {
      set({ notice: errorText(err) });
    } finally {
      setBusy(false);
    }
  };
  return (
    <form className="card promo-code" aria-labelledby="promo-title" onSubmit={(e) => void submit(e)}>
      <h2 id="promo-title" className="label">
        {S.promo.title}
      </h2>
      <div className="join-row">
        <label className="sr-only" htmlFor="promo-code">
          {S.promo.label}
        </label>
        <input
          id="promo-code"
          className="code-input"
          value={code}
          onChange={(e) =>
            setCode(
              e.target.value
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '')
                .slice(0, 24),
            )
          }
          placeholder={S.promo.placeholder}
          inputMode="text"
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck={false}
          enterKeyHint="go"
        />
        <button className="wh-btn wh-btn--carry wh-btn--sm" type="submit" disabled={!ready}>
          {busy ? S.promo.redeeming : S.promo.redeem}
        </button>
      </div>
    </form>
  );
}
